module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-pattern.c5885081.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-pattern.png
// module id = 2826
// module chunks = 11